import React, { useEffect, useState } from 'react';

import { getDevicesByToken } from 'api/traps/DevicesWareHouse/getDevicesByToken';

interface Props {
  onNext: () => void;
  setTrapsList: (traps: any[]) => void;
  tokenTake?: string;
  setToken: (token: string) => void;
}

const GetTokenStep: React.FC<Props> = ({ onNext, setTrapsList, tokenTake, setToken }) => {
  const [token, setTokenState] = useState<string>(tokenTake || '');
  const [errorMessage, setErrorMessage] = useState<string>('');
  const [successMessage, setSuccessMessage] = useState<string>('');
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isValidToken, setIsValidToken] = useState<boolean>(false);

  useEffect(() => {
    if (tokenTake) {
      setTokenState(tokenTake);
    }
  }, [tokenTake]);

  const fetchTraps = async (token: string) => {
    setIsLoading(true);
    try {
      const response = await getDevicesByToken(token);
      if (response.length === 0) {
        setErrorMessage('No devices found for this token.');
        setSuccessMessage('');
        setIsValidToken(false);
      } else {
        setIsValidToken(true);
        setTrapsList(response);
        setErrorMessage('');
        setSuccessMessage('Token is valid. Press "next" button to continue');
      }
    } catch (error) {
      setErrorMessage('Invalid token or all devices already used.');
      setIsValidToken(false);
    } finally {
      setIsLoading(false);
    }
  };

  const handleCheckToken = () => {
    if (token) {
      fetchTraps(token);
    }
  };

  const handleTokenChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setToken(e.target.value);
    if (errorMessage) {
      setErrorMessage('');
    }
    if (successMessage) {
      setSuccessMessage('');
    }
  };

  return (
    <div>
      <h5 className="text-center mb-3">Step 1: Use token </h5>
      <h6 className="text-center text-muted mb-3">to add purchased smart devices to inventory</h6>
      <input
        className={`form-control ${errorMessage && 'border-danger'} ${successMessage && 'border-success'}`}
        type="text"
        value={token}
        onChange={handleTokenChange}
        placeholder="Enter Token"
      />
      {errorMessage && (
        <p className="my-1 mx-3" style={{ color: 'red' }}>
          {errorMessage}
        </p>
      )}
      {successMessage && <p className="my-1 mx-3 text-success">{successMessage}</p>}
      <div className="d-flex justify-content-end mt-3">
        <button
          type="button"
          className="btn mx-1 btn-ghost-success waves-effect waves-light"
          onClick={handleCheckToken}
          disabled={isLoading || !token}
        >
          {isLoading ? 'Loading...' : 'Check Token'}
        </button>

        <button className="btn mx-1 btn-ghost-success" onClick={onNext} disabled={!isValidToken}>
          Next
        </button>
      </div>
    </div>
  );
};

export default GetTokenStep;
